// extracted by mini-css-extract-plugin
export default {"results":"styles_results__m8eTv","player":"styles_player__CZqxy","player_desc":"styles_player_desc__j7rNk","btn":"styles_btn__JPzRb"};